"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withS3Downloader", {
  enumerable: true,
  get: function get() {
    return _S3Downloader["default"];
  }
});
var _S3Downloader = _interopRequireDefault(require("./S3Downloader"));